import { useOnlineStatus, usePendingChanges } from '@/lib/hooks';
import { useT } from '@/lib/i18n';
import { flushOutbox } from '@/lib/sync';

export function OfflineBanner() {
  const t = useT();
  const online = useOnlineStatus();
  const { pending, conflicts } = usePendingChanges();

  if (online && pending === 0 && conflicts === 0) return null;

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 bg-heritage-800 px-4 py-2 text-xs text-white">
      <span>
        {!online
          ? t('Оффлайн-режим. Изменения сохраняются на устройстве.')
          : pending > 0
            ? t('Ожидают отправки: {count}', { count: pending })
            : t('Конфликтов синхронизации: {count}', { count: conflicts })}
      </span>
      {online && pending > 0 && (
        <button
          type="button"
          onClick={() => void flushOutbox()}
          className="rounded-full bg-white/15 px-3 py-1 font-medium hover:bg-white/25"
        >
          {t('Синхронизировать')}
        </button>
      )}
    </div>
  );
}
